import React from "react";
import {
  Visibility,
  Edit,
  Delete,
  MoveDownOutlined,
} from "@mui/icons-material";
import { CustomButtonPlusIcon } from "../Design/CustomButtonPlusIcon";
import Swal from "sweetalert2";
import api from "../../../api/axios";
import TransferUsersDialog from "../TransferUsersDialog";
import { usePermissions } from "../../Context/PermissionProvider";
import { Move, MoveDown } from "lucide-react";

const TableActions = ({
  rute,
  value,
  setChangeDone = () => {},
  changeDone = false,
  showView = false,
  showEdit = false,
  showDelete = false,
  showTransfer = false,
  textTransfer,
  roleFlag = false,
  apiRute = "",
  roles = [],
  module = "",
  completeValue = [],
  userLogged = {},
}) => {
  const [openTransferModal, setOpenTransferModal] = React.useState(false);
  const [usersWithRole, setUsersWithRole] = React.useState([]);
  const [selectedRole, setSelectedRole] = React.useState("");
  const [loadingUsers, setLoadingUsers] = React.useState(false);
  const { can } = usePermissions();

  /* ===============================
     DELETE REAL
     =============================== */
  const confirmDelete = async (id, vista) => {
    console.log(id, vista, apiRute);
    const result = await Swal.fire({
      title: "¿Eliminar definitivamente?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      Swal.fire({
        title: "Eliminando...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/${apiRute || vista}/destroy`,
        { id },
      );

      console.log(response);

      await Swal.fire({
        title: "Eliminado",
        icon: "success",
        timer: 1000,
        timerProgressBar: true,
        showConfirmButton: false,
        showCancelButton: false,
      });

      setChangeDone((prev) => !prev);
    } catch (error) {
      console.error("Error al eliminar el registro:", error); // Opcional, para debug
      Swal.fire(
        "Error",
        `No se pudo eliminar el registro: ${error.message || error}`,
        "error",
      );
    }
  };

  /* ===============================
     CLICK DELETE
     =============================== */
  const handleDelete = async (id, vista) => {
    if (!roleFlag) return confirmDelete(id, vista);

    try {
      setUsersWithRole([]);
      setSelectedRole("");
      setLoadingUsers(true);
      setOpenTransferModal(true);

      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/users/search`,
        { type: id, roleflag: true },
      );

      if (data?.type?.length > 0) {
        setUsersWithRole(data.type);
      } else {
        setOpenTransferModal(false);

        await Swal.fire({
          title: "Sin usuarios asociados",
          text: "Continuando con la eliminación…",
          timer: 2500,
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });

        confirmDelete(id, vista);
      }
    } catch {
      Swal.fire("Error", "No se pudo verificar usuarios.", "error");
      setOpenTransferModal(false);
    } finally {
      setLoadingUsers(false);
    }
  };

  /* ===============================
     ASIGNAR NUEVO ROL
     =============================== */
  const handleAssignNewRole = async () => {
    const confirm = await Swal.fire({
      title: "¿Asignar nuevo rol?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Asignar",
      cancelButtonText: "Cancelar",
    });

    if (!confirm.isConfirmed) return;

    try {
      Swal.fire({
        title: "Actualizando usuarios...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      await api.post(`${process.env.REACT_APP_API_URL}/roles/newassignment`, {
        list: usersWithRole.map((u) => ({ id: u.id })),
        newrole: selectedRole,
      });

      Swal.fire("Usuarios actualizados", "", "success");
      setOpenTransferModal(false);

      confirmDelete(value, rute);
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "No se pudo completar la transferencia.", "error");
    }
  };

  if (!module) return true;

  return showView || showEdit || showDelete ? (
    <>
      <div
        className="spanClassForTables centerContent"
        style={{ gap: 8, display: "flex", justifyContent: "center" }}>
        {rute == "clientes" && (
          <div style={{ width: "132px" }}>
            {showTransfer &&
              userLogged?.company_id == 1 &&
              userLogged?.type == 1 &&
              completeValue?.company_id == 1 && (
                <CustomButtonPlusIcon
                  icon={MoveDownOutlined}
                  to={`/${textTransfer}/transferir?id=${value}`}
                  text={`Transferir`}
                  size="small"
                  position="start"
                  color="warning"
                  variant="outlined"
                />
              )}
          </div>
        )}
        {showView && can(module, "view") && (
          <CustomButtonPlusIcon
            icon={Visibility}
            to={`/${rute}/ver?id=${value}`}
            size="small"
            color="success"
            variant="outlined"
          />
        )}
        {showEdit && can(module, "edit") && (
          <CustomButtonPlusIcon
            icon={Edit}
            to={`/${rute}/editar?id=${value}`}
            size="small"
            color="info"
            variant="outlined"
          />
        )}

        {showDelete && can(module, "delete") && (
          <CustomButtonPlusIcon
            icon={Delete}
            handleFunction={() => handleDelete(value, rute)}
            size="small"
            color="error"
            variant="outlined"
          />
        )}
      </div>

      <TransferUsersDialog
        open={openTransferModal}
        onClose={() => setOpenTransferModal(false)}
        loading={loadingUsers}
        users={usersWithRole}
        roles={roles}
        selectedRole={selectedRole}
        onRoleChange={setSelectedRole}
        onConfirm={handleAssignNewRole}
        currentRoleId={value}
      />
    </>
  ) : null;
};

export default TableActions;
